
import Vue from 'vue';

Vue.component('bookmark-options-vue', {
  methods: {
    moveToBtn() {
      alert('Move to button clicked') //Will popup the alert for the fractal
    },
    removeBookmarkBtn() {
      alert('Remove bookmark button clicked') //Will popup the alert for the fractal
    },
  }
});





